// extracted by mini-css-extract-plugin
export default {"container":"ChangePassword_container__eGzbW","button":"ChangePassword_button__Eyz7e","cancel_subscription_button":"ChangePassword_cancel_subscription_button__-rm-F"};